export default {"src":"/_next/static/media/bag.45a84ddf.svg","height":17,"width":21};